/**
 * Returns true if the array includes the item, false if not.
 */
export function typesafeArrayIncludes<
  T extends number | string | undefined | null | boolean
>(array: readonly T[] | T[], value: T): boolean {
  return array.includes(value);
}
